import React from 'react';
import {AppContextProvider} from './components/AppContextProvider'
import Viewer from './Viewer';

const App = () => {
  return (
    <AppContextProvider>
      <Viewer></Viewer>
    </AppContextProvider>
  );
};

export default App;

